export default (state) => {
  if (!state.subscriptions || !state.subscriptions.current) {
    return undefined;
  }

  const { id } = state.subscriptions.current;

  return id;
};
